import React, { useState } from "react";
import styled from "styled-components";
import { CompassParagraph } from "../../common/styledComponents";
import { Filter } from "../../../types/PageFilterTypes";
import { darkGreen, lightGreyText } from "../../../styles";

const StyledWrapper = styled.div<{ animate?: boolean }>`
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    transform: ${({ animate }): string => (animate ? "scale(1.15)" : "none")};
  }
`;

export const DynamicRenderContent = ({
  option,
  animate = true,
}: DynamicContentRenderProps): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);

  if (option.component && option.key) {
    const CustomComponent = option.component;
    return (
      <StyledWrapper
        animate={animate}
        onMouseEnter={(): void => setIsHovered(true)}
        onMouseLeave={(): void => setIsHovered(false)}
      >
        <CustomComponent dataIndex={option.key} />
      </StyledWrapper>
    );
  } else {
    return (
      <CompassParagraph
        cursor="pointer"
        color={isHovered ? darkGreen : lightGreyText}
        onMouseEnter={(): void => setIsHovered(true)}
        onMouseLeave={(): void => setIsHovered(false)}
      >
        {option.displayValue}
      </CompassParagraph>
    );
  }
};

type DynamicContentRenderProps = {
  option: Filter;
  animate?: boolean;
};
